// extracted by mini-css-extract-plugin
export default {"link":"Fz-z","disabled":"Gz-z"};